import React from 'react';

import { Component as ArtistItemContainerComponent, TypeConfig as ArtistItemContainerTypeConfig } from './ItemContainer.jsx';
import { Component as ArtistMetaComponent, TypeConfig as ArtistMetaTypeConfig } from './ArtistMeta.jsx';
import { Content as CommonContent } from '../common/Types.jsx';
import { withBlockRendering } from '../utility/Config.jsx';
import ContentContainer from '../common/ContentContainer.jsx';
import * as Image from './Image.jsx';
import * as ItemContainer from '../common/ItemContainer.jsx';
import Name from '../utility/Name.jsx';
import Token from '../utility/Token.jsx';
import { default as _TypeConfig } from '../common/TypeConfig.jsx';
import Utilities from '../utility/Utilities.jsx';

const Blocks = {
    get: (group, data) => [
        ...CommonContent.get(group),
        {
            id: Name.Block.Artist.Image,
            component: Image.Component,
            config: {
                Block: Image.TypeConfig.panel.block(),
                Style: Image.TypeConfig.panel.style()
            },
            display: 'Artist Image',
            group,
            image: ''
        },
        {
            id: Name.Block.Artist.Meta,
            component: ArtistMetaComponent,
            config: {
                Block: ArtistMetaTypeConfig.panel.block(),
                Style: ArtistMetaTypeConfig.panel.style(),
                Description: ArtistMetaTypeConfig.panel.description(),
                Label: ArtistMetaTypeConfig.panel.label(),
                Value: ArtistMetaTypeConfig.panel.value()
            },
            display: 'Artist Meta',
            group,
            image: ''
        },
        {
            id: Name.Block.Inventory.Container,
            component: ArtistItemContainerComponent,
            config: {
                Block: ArtistItemContainerTypeConfig.panel.block(),
                Style: ArtistItemContainerTypeConfig.panel.style(),
                Visibility: ArtistItemContainerTypeConfig.panel.visibility(),
                defaults: [
                    { configName: 'Block', propertyName: 'design', propertyValue: ArtistItemContainerTypeConfig.defaultDesign(data) }
                ]
            },
            display: 'Item Container',
            group,
            image: '',
            type: 'container'
        }
    ]
}

function Page(props) {
    const data = props.data || {};
    const visibilityHash = Utilities.Config.getVisibilityHash({ block: props.config });
    let className = 'itemContainer';
    if (props.className) {
        className += ` ${props.className}`;
    }
    return (
        <ItemContainer.Page
            {...props}
            className={className}
            itemContentContainer={ArtistContentContainer}
            items={data.Artists}
            visibility={props.config && props.config.config && props.config.config.Visibility}
            visibilityHash={visibilityHash} />
    );
}

const _ArtistContentContainer = withBlockRendering(ContentContainer, Blocks.get(), (props, block) => {
    if (!block.type) {
        return;
    }
    switch (block.type.value) {
        case Name.Block.Columns:
            if (block.config && block.config.Block && block.config.Block.renderHeaderOnlyFirst) {
                return { renderHeader: props.index == 0 }
            }
    }
});
function ArtistContentContainer(props) {
    let config = props.contentConfig;
    if (!config && props.config && props.config.config && props.config.config.Block && props.config.config.Block.design && props.config.config.Block.design.Config) {
        config = Utilities.Config.getDeepCopy(props.config.config.Block.design);
    }
    let componentData;
    if (props.componentData) {
        componentData = props.componentData;
        if (componentData && componentData.length) {
            componentData = componentData[0];
        }
    } else if (props.data && props.data.Artists && props.data.Artists.length) {
        componentData = { itemData: { ...props.data.Artists[0] } };
    }
    if (!componentData) {
        componentData = {};
    }
    return <_ArtistContentContainer {...props} {...componentData} contentConfig={config} />
}

const TypeConfig = {
    defaultDesign: (data) => ({
        "Config": {
            "blocks": [
                {
                    "config": {
                        "Block": {
                            "maxHeight": {
                                "unit": "px",
                                "value": "600"
                            },
                            "maxWidth": {
                                "unit": "px",
                                "value": "600"
                            }
                        },
                        "Style": {
                            "paddingBottom": {
                                "unit": "px",
                                "value": "20"
                            },
                            "textAlign": "center"
                        }
                    },
                    "id": `${Name.Block.Artist.Image}-${new Date().getTime()}`,
                    "type": {
                        "value": Name.Block.Artist.Image
                    }
                },
                {
                    "config": {
                        "Block": {
                            "count": "1",
                            "displayType": "columns",
                            "rowCount": "1"
                        },
                        "Style": {},
                        "Description": {},
                        "Label": {},
                        "Value": {
                            "design": ArtistMetaTypeConfig.defaultDesign
                        }
                    },
                    "id": `${Name.Block.Artist.Meta}-${new Date().getTime()}`,
                    "type": {
                        "value": Name.Block.Artist.Meta
                    }
                }
            ]
        },
        "Type": Name.Content.ArtistBioItem
    }),
    panel: {
        block: () => ItemContainer.TypeConfig.panel.block('block', Name.Content.ArtistBioItem),
        style: () => _TypeConfig.panel.layoutStyle('block', undefined, {}, undefined, {}),
        visibility: () => {
            return {
                expanded: false,
                label: 'Visibility',
                options: [
                    { display: 'Artist Name', name: Token.Artist.Name, type: 'checkbox', value: true, configurableDuringExport: (_, config) => Token.isTokenPresent(Token.Artist.Name, config, Name.Block.Artist.Meta) },
                    { display: 'Birthdate', name: Token.Artist.Birthdate, type: 'checkbox', value: true, configurableDuringExport: (_, config) => Token.isTokenPresent(Token.Artist.Birthdate, config, Name.Block.Artist.Meta) },
                    { display: 'Deathdate', name: Token.Artist.Deathdate, type: 'checkbox', value: true, configurableDuringExport: (_, config) => Token.isTokenPresent(Token.Artist.Deathdate, config, Name.Block.Artist.Meta) }
                ],
                visible: () => false
            };
        }
    }
}

export {
    Blocks,
    ArtistContentContainer as ContentContainer,
    Page,
    TypeConfig
};